import { Base } from './base.model';

export class Dashboard extends Base {
  public type: string;
  public name: string;
  public isDefault: boolean;
  public defaultState: any;
  public columns: string[];
  public ownerId: string;
}
